export enum LocalStorageModelType {
  MATTER = 'localMatterModel',
  DOCUMENT = 'localDocumentModel',
  EMAIL = 'localEmailModel',
  FOLDER_ITEM = 'localFolderModel',
  CONNECTION = 'localSelectedConnection'
}
